module.exports = __webpack_public_path__ + "img/building.ee9adbc1.png";